<template>
  <div id="licenses">
    <Datatable
      entity="license"
      ref="datatable"
      :globalActions="[
        {text: 'create', method: onRowCreate}
      ]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete}
      ]"
    />
    <Panel :title="license.id ?  ($t('licensing.edit') + ` ${license.id}`) : $t('licensing.new')" style="margin-top: 50px">
      <LicenseForm v-model="license"/>
    </Panel>
    <button class="btn btn-primary" @click="saveLicense">{{$t('save')}}</button>
  </div>
</template>

<script>
import {Core} from "@/core/Core";
import Datatable from "@/components/Datatable.vue";
import LicenseForm from "@/components/qsr/LicenseForm";
import Vue from "vue";

export default {
  name: "Licenses",
  components: {Datatable, LicenseForm},

  data() {
    return {
      license: {
        id: null,
        server: {id: null}
      }
    }
  },

  mounted() {
    if (!this.$store.getters.loggedUserHasSuperAdmin) {
      this.$router.replace("/pos-configuration-hub?branch=" + this.$route.query.branch + "&company=" + this.$route.query.company);
      return;
    }
    this.$store.state.pageTitleTranslationKey = "licensing.title";
    this.$store.state.pageIcon = "/icon/unlocked.svg";
  },

  methods: {
    onRowCreate() {
      this.setFormLicense();
    },
    onRowEdit(row) {
      this.editLicense(row.id);
    },
    onRowDelete(row) {
      this.deleteLicense(row.id);
    },
    setFormLicense(license) {
      if (!license) {
        license = {};
      }
      if (!license.server) {
        license.server = {id: null}
      }
      Vue.set(this, 'license', license);
    },

    async editLicense(id) {
      let license = await Core.request('GET', `/api/licensing/${id}`);
      this.setFormLicense(license);
    },
    async saveLicense() {
      let data = JSON.parse(JSON.stringify(this.license));
      data.server = data.server.id;
      let response = data.id
        ? await Core.request('PUT', `/api/licensing/${data.id}`, data)
        : await Core.request('POST', '/api/licensing', data);

      await this.refreshDatatable();
      this.setFormLicense(response);
    },
    async deleteLicense(id) {
      await Core.request('DELETE', `/api/licensing/${id}`);
      await this.refreshDatatable();
    },

    async refreshDatatable() {
      await this.$refs.datatable.query();
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
